<template>
  <SpinnerComp v-if="loading" />
  <div v-else class="sm:ml-8">
    <h2 class="max-w-7xl mx-auto text-2xl font-bold text-blue-700 mt-8 mb-2">
      Nueva Cotización
    </h2>
    <!-- Generar id -->
    <div class="max-w-7xl mx-auto flex items-center">
      <select
        v-model="num_cotizacion"
        @change="generarId"
        class="p-2 border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        <option>KC</option>
        <option>KS</option>
        <option>KE</option>
      </select>

      <input
        v-model="cotizacion.numero"
        class="border rounded-md p-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        placeholder="Número de cotización"
      />
    </div>
    <!-- Seccion cliente -->
    <div class="max-w-7xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-10">
      <h3 class="text-xl font-bold text-gray-800 text-center mb-6">
        Datos del Cliente
      </h3>
      <form
        @submit.prevent="NewClient"
        class="grid gap-6 sm:grid-cols-1 md:grid-cols-2"
      >
        <div>
          <label for="nombre" class="block text-sm font-medium text-gray-700">
            Nombre:
          </label>
          <input
            id="nombre"
            type="text"
            v-model="cliente.nombre"
            @input="filterClientes"
            placeholder="Nombre del cliente"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-green-500 focus:border-green-500 sm:text-sm"
          />
          <ul
            v-if="cliente.nombre && filteredClientes.length"
            class="mt-2 border border-gray-300 rounded-lg"
          >
            <li
              v-for="filteredCliente in filteredClientes"
              :key="filteredCliente.id"
              @click="selectCliente(filteredCliente)"
              class="cursor-pointer p-2 hover:bg-gray-200"
            >
              {{ filteredCliente.nombre }}
            </li>
          </ul>
        </div>
        <div>
          <label for="rfc" class="block text-sm font-medium text-gray-700">
            RFC:
          </label>
          <input
            id="rfc"
            type="text"
            v-model="cliente.rfc"
            placeholder="RFC"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-green-500 focus:border-green-500 sm:text-sm"
          />
        </div>
        <div class="sm:col-span-2">
          <label for="calle" class="block text-sm font-medium text-gray-700">
            Calle y Número:
          </label>
          <input
            id="calle"
            type="text"
            v-model="cliente.calle"
            placeholder="Calle y número"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-green-500 focus:border-green-500 sm:text-sm"
          />
        </div>
        <div>
          <label for="colonia" class="block text-sm font-medium text-gray-700">
            Colonia y Código Postal:
          </label>
          <input
            id="colonia"
            type="text"
            v-model="cliente.colonia"
            placeholder="Colonia y código postal"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-green-500 focus:border-green-500 sm:text-sm"
          />
        </div>
        <div>
          <label
            for="municipio"
            class="block text-sm font-medium text-gray-700"
          >
            Municipio:
          </label>
          <input
            id="municipio"
            type="text"
            v-model="cliente.municipio"
            placeholder="Municipio"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-green-500 focus:border-green-500 sm:text-sm"
          />
        </div>
        <div class="sm:col-span-2 text-right">
          <button
            type="submit"
            class="inline-flex justify-center py-2 px-4 w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
          >
            Guardar Cliente
          </button>
        </div>
      </form>
    </div>
    <!-- Seccion Colaborador -->
    <div class="max-w-7xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-10">
      <h3 class="text-xl font-bold text-gray-800 text-center mb-6">
        Datos del Colaborador
      </h3>
      <form
        @submit.prevent="NewCollaborator"
        class="grid gap-6 sm:grid-cols-1 md:grid-cols-2"
      >
        <div>
          <label
            for="colaborador"
            class="block text-sm font-medium text-gray-700"
          >
            Nombre:
          </label>
          <input
            id="colaborador"
            type="text"
            v-model="colaborador.colaborador"
            @input="filterColaboradores"
            placeholder="Ingrese nombre del colaborador"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-green-500 focus:border-green-500 sm:text-sm"
          />
          <ul
            v-if="colaborador.colaborador && filteredColaboradores.length"
            class="mt-2 border border-gray-300 rounded-lg"
          >
            <li
              v-for="filteredColaborador in filteredColaboradores"
              :key="filteredColaborador.id"
              @click="selectColaborador(filteredColaborador)"
              class="cursor-pointer p-2 hover:bg-gray-200"
            >
              {{ filteredColaborador.colaborador }}
            </li>
          </ul>
        </div>
        <div>
          <label for="telefono" class="block text-sm font-medium text-gray-700">
            Teléfono:
          </label>
          <input
            id="telefono"
            type="text"
            v-model="colaborador.telefono"
            placeholder="Ingrese teléfono"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-green-500 focus:border-green-500 sm:text-sm"
          />
        </div>
        <div class="sm:col-span-2">
          <label for="correo" class="block text-sm font-medium text-gray-700">
            Correo:
          </label>
          <input
            id="correo"
            type="email"
            v-model="colaborador.correo"
            placeholder="Ingrese correo"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-green-500 focus:border-green-500 sm:text-sm"
          />
        </div>
        <div class="sm:col-span-2 text-right">
          <button
            type="submit"
            class="inline-flex justify-center py-2 px-4 w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
          >
            Guardar Colaborador
          </button>
        </div>
      </form>
    </div>
    <!-- Seccion Productos -->
    <div class="max-w-7xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-10">
      <h3 class="text-xl font-bold text-gray-800 text-center mb-6">
        Datos Productos
      </h3>
      <!-- Seccion de  Productos Seleccionados -->
      <div v-if="selectedProducts.length > 0" class="mt-4">
        <h2 class="text-lg font-bold mb-2">Productos Seleccionados</h2>
        <div
          class="overflow-x-auto overflow-y-auto"
          style="
            max-height: 300px;
            border: 1px solid #d1d5db;
            border-radius: 0.375rem;
          "
        >
          <table class="min-w-full bg-white border-collapse border-spacing-0">
            <thead class="bg-gray-700 sticky top-0">
              <tr>
                <th
                  v-for="column in columns"
                  :key="column.key"
                  class="px-3 py-2 text-left text-xs font-medium text-white border-b border-gray-300"
                >
                  {{ column.label }}
                </th>
                <th
                  class="px-3 py-2 text-left text-xs font-medium text-white border-b border-gray-300"
                >
                  Acción
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(product, index) in selectedProducts" :key="index">
                <td
                  v-for="column in columns"
                  :key="column.key"
                  class="px-3 py-2 text-sm text-gray-800 border-b border-gray-300"
                >
                  <span v-if="column.key === 'idProP'">
                    {{
                      proveedores.find((p) => p.idP === product[column.key])
                        ?.nombreP
                    }}
                  </span>
                  <span v-else>
                    {{ product[column.key] }}
                  </span>
                </td>
                <td
                  class="px-3 py-2 text-sm text-gray-800 border-b border-gray-300"
                >
                  <button
                    class="bg-red-500 text-white rounded-full w-10 h-10 flex items-center justify-center"
                    @click="removeProduct(index)"
                  >
                    <i class="fas fa-trash-alt text-lg"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-4 mb-4">
          <table class="w-full bg-white border border-gray-300 rounded-lg">
            <thead class="bg-gray-200">
              <tr>
                <th
                  class="px-3 py-2 text-left text-sm font-medium text-gray-700"
                >
                  Total:
                </th>
                <td
                  class="px-3 py-2 text-right text-sm font-medium text-gray-800"
                >
                  ${{ calculateTotal }}
                </td>
              </tr>
            </thead>
          </table>
        </div>
      </div>
      <div class="flex flex-wrap justify-center gap-4 mb-6">
        <button
          @click="openModal"
          class="py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Agregar Productos
        </button>
        <button
          @click="generarCotizacion"
          class="py-2 px-4 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
        >
          Generar Cotización
        </button>
        <button
          @click="vistaPreviaCotizacion"
          class="py-2 px-4 bg-gray-600 hover:bg-gray-700 text-white text-sm font-medium rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        >
          Vista Previa
        </button>
      </div>

      <div class="grid gap-6 sm:grid-cols-1 md:grid-cols-2">
        <div>
          <label
            for="descripcion"
            class="block text-sm font-medium text-gray-700"
            >Descripción Cotización:</label
          >
          <textarea
            id="descripcion"
            placeholder="Ingrese descripción"
            v-model="descripcion"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          ></textarea>
        </div>
        <div>
          <label for="notas" class="block text-sm font-medium text-gray-700"
            >Notas Cotización:</label
          >
          <textarea
            id="notas"
            placeholder="Ingrese notas"
            v-model="notas"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          ></textarea>
        </div>
        <div>
          <label
            for="referencia"
            class="block text-sm font-medium text-gray-700"
            >Referencia Cotización:</label
          >
          <input
            id="referencia"
            type="text"
            v-model="referencia"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
        </div>
      </div>

      <div class="grid gap-6 sm:grid-cols-1 md:grid-cols-2">
        <div>
          <label
            for="forma-pago"
            class="block text-sm font-medium text-gray-700"
            >Forma de Pago:</label
          >
          <select
            id="forma-pago"
            v-model="formaPago"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            <option value="Crédito">Crédito</option>
            <option value="Contado">Contado</option>
            <option value="Otro">Otro</option>
          </select>
        </div>
        <div>
          <label for="validez" class="block text-sm font-medium text-gray-700"
            >Validez de la oferta:</label
          >
          <select
            id="validez"
            v-model="validez"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            <option value="5">5 días</option>
            <option value="10">10 días</option>
            <option value="15">15 días</option>
            <option value="20">20 días</option>
          </select>
        </div>
        <div>
          <label for="moneda" class="block text-sm font-medium text-gray-700"
            >Moneda:</label
          >
          <select
            id="moneda"
            v-model="moneda"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            <option value="MXN">Pesos</option>
            <option value="USD">Dólar</option>
            <option value="EUR">Euro</option>
          </select>
        </div>
        <div>
          <label
            for="condiciones"
            class="block text-sm font-medium text-gray-700"
            >Condiciones de pago:</label
          >
          <select
            id="condiciones"
            v-model="condiciones"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            <option value="Sin condiciones">Sin condiciones</option>
            <option value="Ver Notas">Ver notas</option>
            <option value="15 días">15 días</option>
            <option value="30 días">30 días</option>
          </select>
        </div>
        <div>
          <label for="lab" class="block text-sm font-medium text-gray-700"
            >L.A.B:</label
          >
          <select
            id="lab"
            v-model="lab"
            class="mt-1 w-full border border-gray-300 rounded-lg py-2 px-3 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            <option value="Almacén cliente">Almacén Cliente</option>
            <option value="Nuestro almacén">Nuestro Almacén</option>
          </select>
        </div>
      </div>

      <Modal v-if="isModalOpen" :isOpen="isModalOpen" @close="closeModal" />
    </div>
  </div>
  <addProduct
    v-if="isModalOpen"
    :isOpen="isModalOpen"
    :selected-products="selectedProducts"
    @close="closeModal"
    @products-updated="handleProductsUpdated"
  />
</template>

<script>
import addProduct from "@/components/ModalAddProductsComp.vue";
import SpinnerComp from "@/components/SpinnerComp.vue";
export default {
  data() {
    return {
      proveedores: [],
      isModalOpen: false,
      referencia: "S/Ref",
      notas: "* Tiempo de entrega SPV",
      num_cotizacion: "KC",
      formaPago: "Crédito",
      moneda: "MXN",
      condiciones: "15 días",
      descripcion: "",
      validez: 5,
      lab: "Almacén cliente",
      cotizacion: {
        numero: " ",
        idCot: " ",
      },
      cliente: {
        nombre: "",
        rfc: "",
        calle: "",
        colonia: "",
        municipio: "",
      },
      colaborador: {
        nombre: "",
        telefono: "",
        correo: "",
      },
      columns: [
        { label: "Código", key: "codigo" },
        { label: "Nombre", key: "nombre" },
        { label: "Descripción del Producto", key: "descripcion" },
        { label: "Ud.", key: "unidad" },
        { label: "T.E.(d)", key: "te" },
        { label: "Cantidad", key: "cantidad" },
        { label: "Costo Prov", key: "precio" },
        { label: "Utilidad", key: "utilidad" },
        { label: "Precio Util", key: "precioUtil" },
        { label: "# Cotización P.", key: "cotProP" },
        { label: "Proveedor", key: "idProP" },
      ],
      idCliente: null,
      clientes: [],
      colaboradores: [],
      filteredClientes: [],
      filteredColaboradores: [],
      selectedProducts: [],
      loading: false,
    };
  },
  components: {
    addProduct,
    SpinnerComp,
  },
  methods: {
    generarId() {
      this.loading = true;
      this.$axios
        .post("/generar-id", {
          letras: this.num_cotizacion,
        })
        .then((response) => {
          this.cotizacion.numero = response.data.new_id;
          this.cotizacion.idCot =
            this.num_cotizacion + "-" + this.cotizacion.numero;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getInformation(idCliente) {
      this.$axios
        .get("/getCli")
        .then((response) => {
          this.clientes = response.data.cliente;
        })
        .catch((error) => {
          alert("hay un error con clientes: ", error.response.data.message);
        });

      this.$axios
        .get(`/getEmp/${idCliente}`)
        .then((response) => {
          this.colaboradores = response.data.colaboradores;
        })
        .catch(() => {
          return;
        });
    },
    filterClientes() {
      const query = this.cliente.nombre.toLowerCase();
      this.filteredClientes = this.clientes.filter((cliente) =>
        cliente.nombre.toLowerCase().includes(query)
      );
    },
    selectCliente(cliente = null) {
      this.cliente = { ...cliente };
      this.filteredClientes = [];
      this.idCliente = cliente.id;
      this.getInformation(this.idCliente);
    },
    filterColaboradores() {
      const query = this.colaborador.colaborador.toLowerCase();
      this.filteredColaboradores = this.colaboradores.filter((colaborador) =>
        colaborador.colaborador.toLowerCase().includes(query)
      );
    },
    selectColaborador(colaborador) {
      this.colaborador = { ...colaborador };
      this.filteredColaboradores = [];
    },
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    handleProductsUpdated(products) {
      this.selectedProducts = products;
    },
    removeProduct(index) {
      if (
        Array.isArray(this.selectedProducts) &&
        this.selectedProducts[index]
      ) {
        this.selectedProducts.splice(index, 1);
      } else {
        console.error("Error");
      }
    },
    NewClient() {
      const clienteData = {
        nombre: this.cliente.nombre,
        alias: this.cliente.alias,
        rfc: this.cliente.rfc,
        calle: this.cliente.calle,
        municipio: this.cliente.municipio,
        colonia: this.cliente.colonia,
      };
      this.$axios
        .post("/registerCli", clienteData)
        .then((response) => {
          alert(response.data.message);
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    },
    NewCollaborator() {
      const CollaboratorData = {
        idEmpresa: this.idCliente,
        nombre: this.colaborador.colaborador,
        telefono: this.colaborador.telefono,
        correo: this.colaborador.correo,
      };
      this.$axios
        .post("/registerCol", CollaboratorData)
        .then((response) => {
          alert(response.data.message);
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    },
    getProveedores() {
      this.$axios.get("/getPrv2").then((response) => {
        this.proveedores = response.data.proveedores;
      });
    },
    generarCotizacion() {
      let today = new Date();

      let day = String(today.getDate()).padStart(2, "0");
      let month = String(today.getMonth() + 1).padStart(2, "0"); // +1 porque los meses van de 0 a 11
      let year = today.getFullYear();

      let formattedDate = `${year}-${month}-${day}`;
      this.$axios
        .post("/registerCot", {
          id: this.cotizacion.idCot,
          condPago: this.condiciones,
          detalles: this.selectedProducts,
          estatus: "Pendiente",
          fecha: formattedDate,
          formaPago: this.formaPago,
          idColab: this.colaborador.id,
          cotizacion: this.cotizacion,
          descripcion: this.descripcion,
          lab: this.lab,
          id_cliente: this.idCliente,
          moneda: this.moneda,
          referencia: this.referencia,
          validez: this.validez,
          notas: this.notas,
        })
        .then((response) => {
          alert(response.data.message);
          this.generatePDF(response.data.cotizacion);
          this.$router.push("/cotizaciones");
        })
        .catch((error) => {
          alert("Hay campos sin completar.");
          console.error("Error al generar la cotizacion:", error);
        });
    },
    generatePDF(id) {
      this.$axios
        .get(`/generate-pdf/${id}`, {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          const newTab = window.open(url, "_blank");

          if (
            !newTab ||
            newTab.closed ||
            typeof newTab.closed === "undefined"
          ) {
            const link = document.createElement("a");
            link.href = url;
            link.download = `archivo-${id}.pdf`;
            link.click();

            alert(
              "El PDF no pudo abrirse en una nueva ventana. Se descargará automáticamente."
            );
          }
        })
        .catch((error) => {
          alert(error.response?.data?.message || "Error al generar el PDF");
        });
    },

    vistaPreviaCotizacion() {
      let today = new Date();
      let day = String(today.getDate()).padStart(2, "0");
      let month = String(today.getMonth() + 1).padStart(2, "0");
      let year = today.getFullYear();
      let formattedDate = `${year}-${month}-${day}`;

      const dataToSend = {
        cotizacion: JSON.parse(JSON.stringify(this.cotizacion)),
        cliente: JSON.parse(JSON.stringify(this.cliente)),
        colaborador: JSON.parse(JSON.stringify(this.colaborador)),
        detalles: JSON.parse(JSON.stringify(this.selectedProducts)),
        estatus: "Pendiente",
        fecha: formattedDate,
        formaPago: this.formaPago,
        descripcion: this.descripcion,
        lab: this.lab,
        id_cliente: this.idCliente,
        moneda: this.moneda,
        referencia: this.referencia,
        validez: this.validez,
        notas: this.notas,
      };
      this.$axios
        .post("/preview-pdf", dataToSend, {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        })
        .catch((error) => {
          alert("Hay campos sin completar.");
          console.error("Error al generar vista previa:", error);
        });
    },
  },
  mounted() {
    this.generarId();
    this.getInformation();
    this.getProveedores();
  },
  computed: {
    calculateTotal() {
      return this.selectedProducts
        .reduce((sum, product) => {
          return sum + (product.precioUtil * product.cantidad || 0);
        }, 0)
        .toFixed(2);
    },
  },
};
</script>
